import { Component, OnInit, Input, Output, EventEmitter, OnChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import * as moment from 'moment';

import { AppService } from '../../app.service';
import { AccountService } from './../account.service'
import { LoaderEvent, SetAllMemberCheck } from './../../shared/message.event';
import { ManualInvoice } from './../manual-invoice';
import { UtilityFunctions } from './../../shared/utility-functions';
import { CONSTANT_MESSAGES } from '../../constants/constants-messages';
import { Subject } from 'rxjs/Subject';
@Component({
	selector: 'generate-invoice',
	templateUrl: './generate-invoice.component.html',
	styleUrls: ['./generate-invoice.component.css'],
	providers: [LoaderEvent, SetAllMemberCheck, AccountService],
	exportAs: 'generateInvoice'

})
export class GenerateInvoice implements OnInit {
	private vendor;
	private windowHeight = window.innerHeight;
	private topNav = 56;
	private midNav = 45;
	private footer = 35;
	private container = 20;
	private height: any;
	private divHeight = 30;
	private memberTableHeight = 55;
	private invoice: ManualInvoice;
	private selectedReceiver = '';
	private addNewMemberFlag = false;
	private selectNewMembers = [];
	private popUpMessage = '';
	private showMemberList = false;
	private receiverList = ['All Members', 'Specific Members'];
	private isopen = false;
	private validate = {
		subject: '',
		description: '',
		link: '',
		amount: '',
		GSTValue: '',
		sendToAllMembers: false,
		sendToSpecificMembers: '',
		url: ''
	}
	private onePagePerItem = 10; // It will set by vendor configuration object
	private popupTitle = '';
	private pageOptions = {
		currentPage: 1,
		noOfPageItem: this.onePagePerItem
	};
	private currentPage = 1;
	private memberList = [];
	private totalSizeOfList = 0;
	private noMemberAvailable: boolean = true;
	@ViewChild('memberTable')
	tableVariable: any;
	private setChecked = [];
	@Input() search = '';
	@Output() disableSearch = new EventEmitter<boolean>();
	private utilityFunctions = new UtilityFunctions();
	private selectedMemberList = [];
	private generatedInvoice;
	constructor(private loaderEvent: LoaderEvent, private appService: AppService, private setAllMemberCheck: SetAllMemberCheck, private accountService: AccountService) {
		this.height = (this.windowHeight - (this.topNav + this.midNav + 150)) + 'px';
	}
	ngOnInit() {
		if (localStorage.getItem('vendor')) {
			this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
		} else {
		}

		this.resetInvoice();
		this.pagination(this.pageOptions, 1);
	}

	applySearch() {
		this.pagination(this.pageOptions, 1);
	}

	showInvoiceDetails(manualInvoice, popupObj) {
		if (this.validateAll(popupObj)) {
			let members = [];
			this.selectedMemberList.filter(function (rec: any) {
				members.push(rec.userId);
			});
			let reqObj = {
				"vendorId": this.vendor._id,
				"subject": this.invoice.subject,
				"description": this.invoice.description,
				"panaltyLink": this.invoice.link,
				"amount": this.invoice.amount,
				"isGSTApplicable": this.invoice.isGSTApplicable,
				"GSTValue": this.invoice.GSTValue,
				"paymentPendingMembers": this.selectedReceiver == 'Specific Members' ? members : 'all',
				"clubName": this.vendor.clubName,
				'currency': this.vendor.country == 'India' ? 'INR' : 'USD',
				'timezoneOffset': this.vendor.timezoneOffset
			};
			this.loaderEvent.fire(false);
			this.accountService.generateInvoice(reqObj).then((result: any) => {
				this.loaderEvent.fire(true);
				if (result.status === 'SUCCESS') {
					this.generatedInvoice = result.data;
					this.generatedInvoice['paymentPendingMembers'] = this.selectedReceiver == 'Specific Members' ? members : 'all';
					this.generatedInvoice['clubName'] = this.vendor.clubName;
					this.generatedInvoice['currency'] = this.vendor.country == 'India' ? 'INR' : 'USD';
					this.generatedInvoice['timezoneOffset'] = this.vendor.timezoneOffset;
					manualInvoice.showChildModal(result.data, this.selectedReceiver);
				} else {
				}
			});
		}
	}
	resetInvoice() {
		this.invoice = {
			subject: '',
			description: '',
			link: '',
			amount: '',
			GSTValue: 0,
			sendToSpecificMembers: '',
			currency: '',
			vendorId: '',
			isGSTApplicable: false
		}
		this.selectNewMembers = [];
		this.setChecked = [];
		this.memberList = [];
		this.selectedMemberList = [];
		this.selectedReceiver = '';
		this.validate = {
			subject: '',
			description: '',
			link: '',
			amount: '',
			GSTValue: '',
			sendToAllMembers: false,
			sendToSpecificMembers: '',
			url: ''
		}
		this.showMemberList = false;
	}
	pagination(pageOptions, pageNo) {
		this.currentPage = 1;
		if (pageOptions) {
			this.pageOptions = pageOptions;
		}

		let vendorObject = {
			'vendorId': this.vendor._id,
			perPage: this.pageOptions.noOfPageItem,
			pageNumber: pageNo ? pageNo : this.pageOptions.currentPage,
			filters: []
		};
		if (this.addNewMemberFlag) {
			vendorObject.filters = [{
				type: 'exclude',
				values: this.setChecked
			}];
		}
		if ((this.search + '').trim()) {
			vendorObject['filters'].push({
				type: 'search',
				values: this.search
			});
			if (this.tableVariable) {
				this.tableVariable.currentPage = pageNo ? pageNo : this.pageOptions.currentPage;
			}
		}
		this.getMemberListByVendor(vendorObject);
	}
	/**
	 * Get member list by vendor
	 *
	 * @param {any} vendorObj
	 *
	 * @memberOf BroadcastComponent
	 */
	getMemberListByVendor(vendorObj) {
		this.loaderEvent.fire(false);
		let that = this;
		this.appService.getListOfMember(vendorObj).then((result: any) => {
			if (result.status === 'SUCCESS') {
				this.memberList = result.memberList;
				this.totalSizeOfList = result.total;
				this.noMemberAvailable = (result.total > 0);
				this.memberList.map(function (mem) {
					if (!mem.isBlackListed) {
						mem.enable = 'Active';
					} else {
						mem.enable = 'Inactive';
					}
					mem.signedUpOn = moment(mem.signedUpOn).format('DD/MM/YYYY');
					if (mem.hasLeftService) {
						mem.leftServiceDate = that.utilityFunctions.maketimeZoneOfsetDate(mem.leftServiceDate).format('DD/MM/YYYY');
					}
					return mem;
				});
			}
			this.setCheckedList();
			that = this;
			if (this.selectedMemberList.length > 0) {
				this.memberList = this.memberList.filter(function (rec: any) {
					if (_.some(that.selectedMemberList, rec)) {
						rec.isChecked = true;
					}
					return rec;
				});
				this.setAllMemberCheck.fire(true);
			}
			this.loaderEvent.fire(true);
		}).catch((err) => {
			//this.popUpMessage = err;
			this.loaderEvent.fire(true);
		});
	}

	validateFields(para) {
		let flag = true;
		switch (para) {
			case 'subject':
				if (!this.invoice.subject.trim()) {
					this.validate.subject = 'required';
					flag = false;
				} else {
					this.validate.subject = '';
				}
				break;
			case 'description':
				if (!this.invoice.description.trim()) {
					this.validate.description = 'required';
					flag = false;
				} else {
					this.validate.description = '';
				}
				break;
			case 'amount':
				if (!this.invoice.amount) {
					this.validate.amount = 'required';
					flag = false;
				} else {
					this.validate.amount = '';
				}
				break;
			case 'gst':
				if (this.invoice.isGSTApplicable && !this.invoice.GSTValue) {
					this.validate.GSTValue = 'required';
					flag = false;
				} else {
					this.validate.GSTValue = '';
				}
				break;
		}
	}

	validateAll(popupObj) {
		let flag = true;
		if (!this.invoice.subject.trim()) {
			this.validate.subject = 'required';
			flag = false;
		} else {
			this.validate.subject = '';
		}
		if (!this.invoice.description.trim()) {
			this.validate.description = 'required';
			flag = false;
		} else {
			this.validate.description = '';
		}
		if (!this.invoice.amount) {
			this.validate.amount = 'required';
			flag = false;
		} else {
			this.validate.amount = '';
		}
		if (this.invoice.isGSTApplicable && !this.invoice.GSTValue) {
			this.validate.GSTValue = 'required';
			flag = false;
		} else {
			this.validate.GSTValue = '';
		}
		if (this.checkUrl(this.invoice.link, 'url')) {
			flag = false;
		}
		if ((this.selectedReceiver == '' && flag) || (flag && this.selectedMemberList.length < 0)) {
			this.popUpMessage = 'Select member to send invoice';
			popupObj.showChildModal();
			flag = false;
		}
		return flag;
	}

	checkUrl(url, field) {
		let regEx = /^http(s)?:\/\/(www\.)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
		if (url) {
			if (!regEx.test(url)) {
				this.validate[field] = 'required';
				return true;
			} else {
				this.validate[field] = '';
				return false;
			}
		} else {
			this.validate[field] = '';
		}
	}

	SetGSTApplicable(event) {
		if (event.target.checked) {
			this.invoice.isGSTApplicable = event.target.checked;
		} else {
			this.invoice.isGSTApplicable = false;
			this.invoice.GSTValue = 0;
			this.validate.GSTValue = ''
		}
	}

	actionOnCriteria(para) {
		this.selectedReceiver = para;
		this.isopen = false;
		if (this.selectedReceiver == 'Specific Members') {
			this.showMemberList = true;
			this.disableSearch.emit(false);
			this.pagination(this.pageOptions, 1);
		}
	}
	/**
 * Store selected member list against pagination
 *
 *
 * @memberOf BroadcastComponent
 */
	setCheckedList() {
		let flagAllChecked = true;
		for (let mem of this.memberList) {
			if (!mem.isChecked) {
				flagAllChecked = false;
				break;
			}
		}
		if (this.tableVariable) {
			if (flagAllChecked) {
				this.tableVariable.allInGroup = true;
			} else {
				this.tableVariable.allInGroup = false;
			}
		}
	}
	/**
 * Select specific member with check box selection
 *
 * @param {*} memberObj
 *
 * @memberOf BroadcastComponent
 */
	selectSpecificMembers(memberObj: any) {
		if (memberObj.isChecked) {
			this.selectedMemberList.push(memberObj);
			this.selectNewMembers.push(memberObj);
		} else {
			_.remove(this.selectedMemberList, function (n) {
				return n.userId === memberObj.userId;
			});
			_.remove(this.selectNewMembers, function (n) {
				return n.userId === memberObj.userId;
			});
			if (this.tableVariable.allInGroup) {
				this.tableVariable.allInGroup = false;
			}
		}
		this.selectedMemberList = _.uniq(this.selectedMemberList);
	}

	selectAllMembers(memberList: any) {
		try {
			let that = this;
			this.setUserIdListTOSendFeed();
			if (!this.tableVariable.allInGroup) {
				for (let rec of this.memberList) {
					_.remove(that.selectedMemberList, function (n) {
						return n.isChecked === false;
					});
					_.remove(that.selectNewMembers, function (n) {
						return n.isChecked === false;
					});
				}
			} else {
			}
		} catch (e) {
			console.log(e);
		}
	}

	setUserIdListTOSendFeed() {
		for (let mem of this.memberList) {
			if ((this.selectedMemberList.indexOf(mem) < 0)) {
				this.selectedMemberList.push(mem);
			}
			if ((this.selectNewMembers.indexOf(mem) < 0)) {
				this.selectNewMembers.push(mem);
			}
		}
		this.selectedMemberList = _.uniq(this.selectedMemberList);
		this.selectNewMembers = _.uniq(this.selectNewMembers);
	}

	goToComposeMessage(popUpObj) {
		if (this.checkMemberListForSelection()) {
			this.tableVariable.allInGroup = false;
			this.setFlagOnReset();
			this.addNewMemberFlag = false;
		} else {
			this.popUpMessage = 'Select member to send invoice';
			popUpObj.showChildModal();
		}
		this.selectedMemberList = _.uniq(this.selectedMemberList);
	}
	checkMemberListForSelection() {
		return this.selectNewMembers.some(item => {
			return item.isChecked;
		});
	}

	setFlagOnReset() {
		this.showMemberList = false;
		this.disableSearch.emit(true);
		this.isopen = false;
		//this.ideal = true;
		//this.cancelForReset = false;
	}

	showSelectedItems(popupObj, popupForMember) {
		switch (this.selectedReceiver) {
			case 'Specific Members':
				if (this.selectedMemberList.length > 0) {
					popupForMember.showChildModal();
				} else {
					this.popUpMessage = 'There no selected recipients.'
				}
				break;
		}
	}

	removeFromSelection(member) {
		for (let item of this.selectedMemberList) {
			if (item.userId === member.userId) {
				_.remove(this.selectedMemberList, function (n) {
					return n.userId === member.userId;
				});
				break;
			}
		}
		if (this.selectedMemberList.length === 0) {
			this.selectedReceiver = '';
		}
	}

	addRecipants() {
		this.search = '';
		this.selectedMemberList = _.uniq(this.selectedMemberList);
		let that = this;
		switch (this.selectedReceiver) {
			case 'Specific Members':
				this.setChecked = [];
				this.selectNewMembers = [];
				this.showMemberList = true
				this.disableSearch.emit(false);
				for (let item of this.selectedMemberList) {
					this.setChecked.push(item.userId);
				}
				this.addNewMemberFlag = true;
				this.pagination(this.pageOptions, 1);
				break;
		}
	}

	removeMemberList() {
		this.showMemberList = false;
		this.search = '';
		this.disableSearch.emit(true);
		let that = this;
		this.selectNewMembers.filter(function (rec: any) {
			if (_.find(that.selectNewMembers, rec)) {
				_.remove(that.selectedMemberList, rec);
			}
		});
		this.selectNewMembers = [];
		if (this.selectedMemberList.length > 0) {
			for (let member of this.memberList) {
				for (let item of this.selectedMemberList) {
					if (member.userId === item.userId) {
						member.isChecked = true;
					} else {
						member.isChecked = false;
					}
					break;
				}
			}
		}

		this.addNewMemberFlag = false;
		if (this.selectedMemberList.length <= 0) {
			this.selectedReceiver = '';
			this.memberList.filter(function (rec: any) {
				rec.isChecked = false;
				return rec;
			});
		}
	}

	senInvoiceToSelectedMember(event, popupObj) {
		if (event) {
			this.loaderEvent.fire(false);
			this.accountService.sendInvoice(this.generatedInvoice).then((result: any) => {
				this.loaderEvent.fire(true);
				if (result.status === 'SUCCESS') {
					this.popupTitle = 'Invoice Sent';
					this.popUpMessage = 'The invoice has been sent successfully!';
					popupObj.showChildModal();
					this.resetInvoice();
				} else {
				}
			});
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/account/generate-invoice/generate-invoice.component.ts